export const ENV_VARS = {
  BASE_API_URL: process.env.NEXT_PUBLIC_BASE_API_URL
    ? `${process.env.NEXT_PUBLIC_BASE_API_URL}`
    : "http://localhost:8000/api",
};

export const BASE_API_URL = ENV_VARS.BASE_API_URL;
export const MODEL_BASE_URL = `${ENV_VARS.BASE_API_URL}/openai/v1`;
export const PLATFORM_BASE_URL = `${ENV_VARS.BASE_API_URL}/platform/v1`;
export const CHAT_COMPLETION_URL = `${MODEL_BASE_URL}/chat/completions`;
export const CHAT_TRANSCRIPTION_URL = `${MODEL_BASE_URL}/audio/transcriptions`;
export const TEXT_TO_SPEECH_URL = `${MODEL_BASE_URL}/audio/speech`;
